import * as React from 'react'

const Providers = (props: { className: 'string' }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Providers' clipPath='url(#clip0)'>
          <g id='Vector'>
            <path
              d='M 18.7826 0.5L 2.08696 0.5C 1.2194 0.5 0.5 1.21941 0.5 2.10537L 0.5 16.343L 4.17391 16.343L 18.7826 16.343C 19.6502 16.343 20.3696 15.6236 20.3696 14.7376L 20.3696 2.10537C 20.3696 1.21941 19.6502 0.5 18.7826 0.5Z'
              transform='translate(3.13 5.157)'
              fill='#fff'
            />
            <path
              d='M 18.7826 0.5L 2.08696 0.5C 1.2194 0.5 0.5 1.21941 0.5 2.10537L 0.5 16.343L 4.17391 16.343L 18.7826 16.343C 19.6502 16.343 20.3696 15.6236 20.3696 14.7376L 20.3696 2.10537C 20.3696 1.21941 19.6502 0.5 18.7826 0.5Z'
              strokeMiterlimit='8'
              transform='translate(3.13 5.157)'
            />
          </g>
          <g id='Vector_2'>
            <path
              d='M 18.7826 0.5L 2.08696 0.5C 1.2194 0.5 0.5 1.21941 0.5 2.10537L 0.5 16.343L 4.17391 16.343L 18.7826 16.343C 19.6502 16.343 20.3696 15.6236 20.3696 14.7376L 20.3696 2.10537C 20.3696 1.21941 19.6502 0.5 18.7826 0.5Z'
              transform='translate(0 2)'
            />
            <path
              d='M 18.7826 0.5L 2.08696 0.5C 1.2194 0.5 0.5 1.21941 0.5 2.10537L 0.5 16.343L 4.17391 16.343L 18.7826 16.343C 19.6502 16.343 20.3696 15.6236 20.3696 14.7376L 20.3696 2.10537C 20.3696 1.21941 19.6502 0.5 18.7826 0.5Z'
              strokeMiterlimit='8'
              transform='translate(0 2)'
            />
          </g>
          <path
            d='M 11.4978 0.7575C 11.3533 0.315 10.9489 0 10.4722 0L 2.52778 0C 2.05111 0 1.65389 0.315 1.50222 0.7575L 0 5.25L 0 11.25C 0 11.6625 0.325 12 0.722222 12L 1.44444 12C 1.84167 12 2.16667 11.6625 2.16667 11.25L 2.16667 10.5L 10.8333 10.5L 10.8333 11.25C 10.8333 11.6625 11.1583 12 11.5556 12L 12.2778 12C 12.675 12 13 11.6625 13 11.25L 13 5.25L 11.4978 0.7575ZM 2.52778 8.25C 1.92833 8.25 1.44444 7.7475 1.44444 7.125C 1.44444 6.5025 1.92833 6 2.52778 6C 3.12722 6 3.61111 6.5025 3.61111 7.125C 3.61111 7.7475 3.12722 8.25 2.52778 8.25ZM 10.4722 8.25C 9.87278 8.25 9.38889 7.7475 9.38889 7.125C 9.38889 6.5025 9.87278 6 10.4722 6C 11.0717 6 11.5556 6.5025 11.5556 7.125C 11.5556 7.7475 11.0717 8.25 10.4722 8.25ZM 1.44444 4.5L 2.52778 1.125L 10.4722 1.125L 11.5556 4.5L 1.44444 4.5Z'
            transform='translate(4 4)'
            fill='#fff'
            id='Vector_3'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Providers



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Providers.tsx